import { datadogRum } from '@datadog/browser-rum'

import type { AuthState } from 'utils/auth/authAdapter'

export const setupDatadog = () => {
  const datadogConfig = {
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID || '',
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || '',
    site: 'datadoghq.com',
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE || '',
    env: process.env.NEXT_PUBLIC_DATADOG_ENV || 'dev',
    version: process.env.NEXT_PUBLIC_DATADOG_VERSION || '1.0.0',
    sessionSampleRate: parseInt(
      process.env.NEXT_PUBLIC_DATADOG_SESSION_SAMPLE_RATE || '30'
    ),
    sessionReplaySampleRate: parseInt(
      process.env.NEXT_PUBLIC_DATADOG_SESSION_REPLAY_SAMPLE_RATE || '10'
    ),
    trackResources: process.env.NEXT_PUBLIC_DATADOG_TRACK_RESOURCES === 'true',
    trackUserInteractions:
      process.env.NEXT_PUBLIC_DATADOG_TRACK_USER_INTERACTIONS === 'true',
    trackLongTasks: process.env.NEXT_PUBLIC_DATADOG_TRACK_LONG_TASKS === 'true',
    // Leave this configuration as a future improvement:
    // Backend is not yet prepared to receive the extra headers sent by datadog-rum.
    // For more information, check https://docs.datadoghq.com/tracing/other_telemetry/rum/?tab=browserrum#how-rum-resources-are-linked-to-traces
    // allowedTracingUrls: [
    //   /^https:\/\/[^/]+\.directvgo\.com/,
    //   /^https:\/\/[^/]+\.directvla\.com/
    // ],
    defaultPrivacyLevel:
      (process.env.NEXT_PUBLIC_DATADOG_DEFAULT_PRIVACY_LEVEL as
        | 'allow'
        | 'mask'
        | 'mask-user-input') || 'mask-user-input'
  }
  datadogRum.init(datadogConfig)
}

/**
 * Attaches the currently logged-in user to Datadog RUM so sessions, errors and
 * replays can be grouped/filtered per customer for the whole flow.
 * No-op for anonymous visitors (no userId). Wrapped in onReady so it is safe to
 * call regardless of whether init() has already run (the SDK queues the call).
 */
export const setDatadogUser = (auth: Partial<AuthState>) => {
  if (!auth.userId) return

  const email = auth.user?.userName ?? auth.user?.profile?.email

  datadogRum.onReady(() => {
    datadogRum.setUser({
      id: auth.userId ?? undefined,
      ...(email ? { email } : {})
    })
  })
}

/**
 * Clears the user from Datadog RUM (e.g. on logout).
 */
export const clearDatadogUser = () => {
  datadogRum.onReady(() => {
    datadogRum.clearUser()
  })
}
